<template>
  <v-container fluid class="servicios-container">
    <v-data-table
      mobile-breakpoint="900"
      class="elevation-1"
      color="primary"
      :calculate-widths="true"
      :headers="servicesTblHeaders"
      :items="servicios"
      :search="serviceSearch"
      :expanded.sync="expanded"
      :single-expand="singleExpand"
      show-expand
      :footer-props="dataTableFooterProps"
    >
      <template v-slot:item.precio_venta="{ item }">
        <v-chip color="darkgrey" dark
          >${{ formatPrice(item.precio_venta) }}</v-chip
        >
      </template>
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Servicios</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="serviceSearch"
            append-icon="mdi-magnify"
            hide-details
            label="Buscar servicio"
            class="mx-4"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="newItemDialog" max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" rounded dark class="mb-2" v-on="on"
                >+</v-btn
              >
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Agregar Servicio</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <!-- <v-text-field v-model="editedItem.categoria" label="Categoria"></v-text-field> -->
                      <v-select
                        v-model="newServiceCategory"
                        :items="categoryNames"
                        label="Categoria*"
                        required
                        outlined
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        outlined
                        v-model="newServiceData.descripcion"
                        label="Nombre Servicio*"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        append-icon="mdi-text-short"
                        v-model="newServiceData.detalle"
                        label="Descripcion*"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-select
                        v-model="newServiceData.unidad"
                        :items="unidades"
                        label="Unidad*"
                        required
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        outlined
                        prefix="$"
                        v-model="newServiceData.costo_servicio"
                        label="Costo"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        outlined
                        prefix="$"
                        v-model="newServiceData.precio_venta"
                        label="Precio"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-file-input
                        v-model="newServiceIMG"
                        color="primary accent-4"
                        counter
                        label="Imagen"
                        accepted="image/png, image/jpeg"
                        placeholder="Elige una imagen"
                        prepend-icon="mdi-camera"
                        :rules="rules"
                        :show-size="1000"
                      >
                        <template v-slot:selection="{ index, text }">
                          <v-chip
                            v-if="index < 2"
                            color="primary accent-4"
                            dark
                            label
                            small
                            >{{ text }}</v-chip
                          >

                          <span
                            v-else-if="index === 2"
                            class="overline grey--text text--darken-3 mx-2"
                            >+{{ files.length - 2 }} Imagen(es)</span
                          >
                        </template>
                      </v-file-input>
                    </v-col>
                    <v-col cols="12" sm="5" md="5" offset="1">
                      <v-switch
                        append-icon="mdi-pin"
                        v-model="newServiceData.favorited"
                        label="Favorito"
                        inset
                      ></v-switch>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <template item.action="{ item }">
                  <v-btn color="blue darken-1" text @click="closeCreateDialog"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="saveNew()"
                    >Save</v-btn
                  >
                </template>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="editServiceDialog" max-width="600px">
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <!-- <v-text-field v-model="editedItem.categoria" label="Categoria"></v-text-field> -->
                      <v-select
                        v-model="editServiceCategory"
                        :items="categoryNames"
                        label="Categoria*"
                        required
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        outlined
                        v-model="editedService.descripcion"
                        label="Nombre Servicio"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="editedService.detalle"
                        label="Descripcion"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-select
                        v-model="editedService.unidad"
                        :items="unidades"
                        label="Unidad*"
                        required
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        outlined
                        prefix="$"
                        v-model="editedService.costo_servicio"
                        label="Costo"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        outlined
                        prefix="$"
                        v-model="editedService.precio_venta"
                        label="Precio"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                      <!-- <v-text-field v-model="editedService.imagen" label="Imagen"></v-text-field> -->
                      <v-file-input
                        v-model="newServiceIMG"
                        color="primary accent-4"
                        counter
                        label="Imagen"
                        accepted="image/png, image/jpeg"
                        placeholder="Elige una imagen"
                        prepend-icon="mdi-camera"
                        :rules="rules"
                        :show-size="1000"
                      >
                        <template v-slot:selection="{ index, text }">
                          <v-chip
                            v-if="index < 2"
                            color="primary accent-4"
                            dark
                            label
                            small
                            >{{ text }}</v-chip
                          >

                          <span
                            v-else-if="index === 2"
                            class="overline grey--text text--darken-3 mx-2"
                            >+{{ files.length - 2 }} Imagen(es)</span
                          >
                        </template>
                      </v-file-input>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeEditDialog"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="saveEdited()"
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.id="{ item }">
        <span>{{
          services
            .map(function (x) {
              return x.id;
            })
            .indexOf(item.id) + 1
        }}</span>
      </template>
      <template v-slot:item.descripcion="{ item }">
        <div style="width: 150px; display: flex">
          <h4>{{ item.descripcion }}</h4>
        </div>
      </template>
      <template v-slot:item.favorited="{ item }">
        <FavoritedBtn
          v-model="item.favorited"
          :id="item.id"
          itemType="service"
        />
      </template>
      <template v-slot:item.imagen="{ item }">
        <TableRowImage :imageUrl="item.imagen" />
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td style="text-align: center" :colspan="headers.length">
          {{ item.detalle }}
        </td>
      </template>
      <template v-slot:item.action="{ item }">
        <div class="services__table__actions-col">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon color="red" small @click="deleteItem(item)"
            >mdi-delete</v-icon
          >
        </div>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
// import * as ImagesService from "../services/images_service/ImagesService";

//placed in the window object by the preload and available in the global context
// const { getImageUrl } = api.services.imagesService;
// const { getServicesCategories } = api.services.categoriasService;
// const { saveNew, getServiciosAll, deleteServiceByID, updateServiceByID } =
//   api.services.serviciosService;
import {mapGetters} from 'vuex';

import * as Utils from "../services/utils";
import uiMixin from "../mixins/mixin-ui";
import FavoritedBtn from "../components/FavoritedBtn";
import TableRowImage from "../components/TableRowImage";

export default {
  name: "Servicios",
  mixins: [uiMixin],
  components: {
    FavoritedBtn,
    TableRowImage,
  },
  data: function () {
    return {
      expanded: [],
      singleExpand: true,
      newServiceIMG: null,
      rules: [
        (value) =>
          !value || value.size < 2000000 || "La imagen debe ser menor a 2 MB!",
      ],
      unidades: ["kilo", "pieza", "carga", "par", "docena"],
      calculateWidths: true,
      serviceSearch: "",
      editServiceDialog: false,
      newItemDialog: false,
      servicesTblHeaders: [
        {
          text: "#",
          align: "left",
          sortable: true,
          value: "id",
        },
        {
          text: "Imagen",
          align: "left",
          sortable: false,
          value: "imagen",
        },
        {
          text: "Codigo",
          align: "left",
          sortable: true,
          value: "codigo",
        },
        {
          text: "Servicio",
          align: "left",
          sortable: true,
          value: "descripcion",
        },
        {
          text: "Categoria",
          align: "left",
          sortable: true,
          value: "categoria",
        },
        {
          text: "Unidad",
          align: "left",
          sortable: true,
          value: "unidad",
        },
        {
          text: "Favorito",
          align: "left",
          sortable: false,
          value: "favorited",
        },
        {
          text: "Precio",
          align: "left",
          sortable: true,
          value: "precio_venta",
        },
        { text: "Más", value: "data-table-expand" },
        {
          text: "Admin",
          align: "left",
          sortable: false,
          value: "action",
        },
      ],
      services: [],
      categorias: [],
      editedIndex: -1,
      editedService: {
        categoria: "",
        descripcion: "",
        favorited: 0,
        detalle: "",
        unidad: "",
        costo_servicio: 0.0,
        precio_venta: 0.0,
        imagen: "",
      },
      newService: {
        categoria: "",
        descripcion: "",
        detalle: "",
        favorited: false,
        unidad: "",
        costo_servicio: 0.0,
        precio_venta: 0.0,
        imagen: "",
      },
      defaultItem: {},
    };
  },
  computed: {
    ...mapGetters(['servicesCategories','demoServicios']),
    editServiceCategory: {
      get: function () {
        return this.editedService.categoria;
      },
      set: function (category) {
        this.editedService.categoria = category;
        const { id } = this.categorias.find(
          (categoria) => categoria.categoria == category
        );
        this.editedService.id_categoria = id;
      },
    },
    newServiceData: {
      get: function () {
        return this.newService;
      },
      set: function (data) {
        console.log("Setting newService data [BEFORE]: ", this.newServiceData);
        this.newService = data;
        console.log("Setting newService data [AFTER]: ", this.newServiceData);
      },
    },
    editedServiceData: {
      get: function () {
        return this.editedService;
      },
      set: function (data) {
        console.log(
          "Setting editedService data [BEFORE]: ",
          this.editedService
        );
        this.editedService = data;
        console.log("Setting editedService data [AFTER]: ", this.editedService);
      },
    },
    newServiceCategory: {
      get: function () {
        return this.newService.categoria;
      },
      set: function (category) {
        this.newService.categoria = category;
      },
    },
    newServiceIsValid: {
      get: function () {
        const validCategory =
          this.newService.categoria === null
            ? false
            : this.newService.categoria === ""
            ? false
            : true;
        const validDescription =
          this.newService.descripcion === null
            ? false
            : this.newService.descripcion === ""
            ? false
            : true;
        const validDetail =
          this.newService.detalle === null
            ? false
            : this.newService.detalle === ""
            ? false
            : true;
        const validCost =
          this.newService.costo_servicio === null
            ? false
            : this.newService.costo_servicio === ""
            ? false
            : true;
        const validPrice =
          this.newService.precio_venta === null
            ? false
            : this.newService.precio_venta === ""
            ? false
            : true;
        const validImage = true; //TODO: I need write a function to check that it is a valid url
        return (
          validCategory &&
          validDescription &&
          validDetail &&
          validCost &&
          validPrice &&
          validImage
        );
      },
      set: function () {},
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Servicio" : "Editar Servicio";
    },
    servicios: {
      get: function () {
        return this.services;
      },
      set: function (payload) {
        this.services = payload;
      },
    },
    categoryNames: {
      get: function () {
        const categories = [];
        this.categorias.forEach((categoria) => {
          categories.push(categoria.categoria);
        });

        return categories;
      },
    },
  },
  methods: {
    getImageUrl(){},
    getServicesCategories(){ return this.servicesCategories; },
    saveNewServicio(){},
    getServiciosAll(){ return this.demoServicios; },
    deleteServiceByID(){},
    updateServiceByID(){},
    formatPrice: Utils.formatDecimal,
    fetchServices() {
      this.services = this.getServiciosAll();
    },
    fetchCategories() {
      this.categorias = this.getServicesCategories();
      // this.categorias = this.servicesCategories;
    },
    editItem(item) {
      this.editedIndex = this.servicios.indexOf(item);
      this.editedService = Object.assign({}, item);
      this.editServiceDialog = true;
    },
    deleteItem(item) {
      const index = this.servicios.indexOf(item);
      const confirmation =
        confirm(
          `Seguro quieres borrar el servicio: ${item.codigo} ${item.descripcion}?`
        ) && this.servicios.splice(index, 1);
      const { id } = item;
      if (confirmation) this.deleteServiceByID(id);
    },
    closeEditDialog() {
      this.editServiceDialog = false;
    },
    closeCreateDialog() {
      this.newItemDialog = false;
    },
    saveEdited() {
      const imgName = Utils.removeSpecialChars(
        this.editedServiceData.descripcion
      )
        .split(" ")
        .join("_")
        .toLowerCase();
      console.log("[imgName] ", imgName);
      if (this.newServiceIMG) {
        this.editedServiceData.imagen = this.getImageUrl(
          this.newServiceIMG.path,
          imgName,
          "servicios"
        );
        console.log(
          "[this.editedServiceData.imagen] ",
          this.editedServiceData.imagen
        );
      }

      const info = this.updateServiceByID(this.editedService);
      if (info) {
        this.servicios = this.getServiciosAll();
        this.resetEditedService();
        this.newServiceIMG = null;
        this.closeEditDialog();
      }
    },
    resetNewService() {
      this.newServiceData = {
        categoria: "",
        descripcion: "",
        detalle: "",
        favorited: false,
        unidad: "",
        costo_servicio: 0.0,
        precio_venta: 0.0,
        imagen: "",
      };
    },
    resetEditedService() {
      this.editedServiceData = {
        categoria: "",
        descripcion: "",
        detalle: "",
        favorited: false,
        unidad: "",
        costo_servicio: 0.0,
        precio_venta: 0.0,
        imagen: "",
      };
    },
    saveNew() {
      if (this.newServiceIsValid) {
        const imgName = Utils.removeSpecialChars(
          this.newServiceData.descripcion
        )
          .split(" ")
          .join("_")
          .toLowerCase();
        if (this.newServiceIMG)
          this.newServiceData.imagen = this.getImageUrl(
            this.newServiceIMG.path,
            imgName,
            "servicios"
          );
        const info = this.saveNewServicio(this.newServiceData);
        if (info) {
          this.servicios = this.getServiciosAll();
          this.resetNewService();
          this.newServiceIMG = null;
        }
      } else console.log("service is not valid!");
      this.closeCreateDialog();
    },
  },
  mounted() {
    this.fetchServices();
    this.fetchCategories();
  },
};
</script>

<style scoped>
.servicios-container {
  margin-top: 10px;
}

.services__table__actions-col {
  display: flex;
  flex-wrap: nowrap;
}
</style>